// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.toast-overflow[data-v-616df4be] {\r\n    position: fixed;\r\n    right: 30px;\r\n    z-index: 9999;\r\n    transition: all 1s ease-in-out;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
